import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class SocketService extends Socket {

  constructor(private apiService: ApiService) {
    super({
      url: `${apiService.wsUrl()}/contact`,
      options: {
        auth: {
          get token() {
            return localStorage.getItem('customer_access_token');
          }
        }
      } as any
    });
  }
  
}
